(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["linko-cart-gift"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('linko-cart-gift')) {
  class LinkoCartGift extends HTMLElement {
    static busy = false;
    connectedCallback() {
      this.feedback=this.querySelector('[role="status"]');
      this.readData(this.querySelector('.linko-gift-data'));
      this.buildCards();
      this.loadProducts().then(()=>this.refresh());
      this.onFocus=()=>this.syncData();
      window.addEventListener('focus',this.onFocus);
      this.timer=setInterval(()=>this.syncData(),60000);
    }
    disconnectedCallback() { clearInterval(this.timer); window.removeEventListener('focus',this.onFocus); }
    get root() { return window.Shopify?.routes?.root || '/'; }
    get ids() { return this.cards.map(card=>Number(card.dataset.variant)); }
    money(value) { return new Intl.NumberFormat(document.documentElement.lang || 'zh-Hant',{style:'currency',currency:this.config.currency || 'HKD'}).format(value/100); }
    readData(source) {
      try { this.config=JSON.parse(source?.dataset.config || 'null') || {rules:[]}; this.groups=JSON.parse(source?.dataset.groups || '[]'); }
      catch { this.config={rules:[]}; this.groups=[]; }
    }
    buildCards() {
      const options=this.querySelector('.linko-gift-options');options.replaceChildren();
      const gifts=new Map();
      for (const rule of this.config.rules || []) for (const gift of rule.gifts || []) {
        if (!gifts.has(gift.id)) gifts.set(gift.id,{...gift,rules:[]});gifts.get(gift.id).rules.push(rule.id);
      }
      this.cards=[];
      for (const gift of gifts.values()) {
        const card=document.createElement('div');card.className='linko-gift-card';card.hidden=true;
        card.dataset.variant=gift.id;card.dataset.handle=gift.handle;card.giftRules=gift.rules;
        const image=document.createElement('div');image.className='linko-gift-image';
        const body=document.createElement('div');const link=document.createElement('a');link.href=this.root+'products/'+encodeURIComponent(gift.handle);link.textContent=this.dataset.loading;
        const tier=document.createElement('p');tier.className='linko-gift-tier';
        const price=document.createElement('p');const free=document.createElement('span');free.className='linko-gift-free';free.textContent=this.dataset.free;const strike=document.createElement('s');price.append(free,' ',strike);
        const button=document.createElement('button');button.type='button';button.className='button button--primary';button.disabled=true;button.textContent=this.dataset.busy;button.addEventListener('click',()=>this.addGift(card));
        body.append(link,tier,price,button);card.append(image,body);options.append(card);this.cards.push(card);
      }
    }
    async request(path,payload) {
      const options={credentials:'same-origin',headers:{Accept:'application/json'}};
      if(payload){options.method='POST';options.headers['Content-Type']='application/json';options.body=JSON.stringify(payload);}
      const response=await fetch(this.root+path,options);const data=await response.json();
      if(!response.ok||data.status>=400)throw new Error(data.description||this.dataset.error);return data;
    }
    async syncData() {
      if(LinkoCartGift.busy||this.syncing)return;
      this.syncing=true;
      try {
        const response=await fetch(this.root+'?section_id=linko-gift-data&_linko='+Date.now(),{credentials:'same-origin',cache:'no-store'});
        if(!response.ok)throw new Error();
        const parsed=new DOMParser().parseFromString(await response.text(),'text/html');const source=parsed.querySelector('.linko-gift-data');
        if(!source)throw new Error();
        const previous=JSON.stringify(this.config);this.readData(source);
        if(previous!==JSON.stringify(this.config)){this.buildCards();await this.loadProducts();}
        await this.refresh();
      } catch { if(!this.fresh())this.hidden=true; }
      finally {this.syncing=false;}
    }
    fresh() { const age=Date.now()-Date.parse(this.config.syncedAt || '');return this.config.version===1&&Number.isFinite(age)&&age>=-60000&&age<3600000; }
    async loadProducts() {
      const products=new Map();
      await Promise.allSettled(this.cards.map(async card=>{
        try {
          let pending=products.get(card.dataset.handle);
          if(!pending){pending=this.request('products/'+encodeURIComponent(card.dataset.handle)+'.js');products.set(card.dataset.handle,pending);}
          const product=await pending;const variant=product.variants.find(item=>item.id===Number(card.dataset.variant));
          card.dataset.available=String(Boolean(variant?.available));
          card.querySelector('a').textContent=product.title+(variant?.title&&variant.title!=='Default Title'?' · '+variant.title:'');
          card.querySelector('s').textContent=this.money(variant?.price || 0);
          const src=variant?.featured_image?.src || product.featured_image;
          if(src){const img=document.createElement('img');img.src=src;img.alt=product.title;img.width=64;img.height=64;img.loading='lazy';card.querySelector('.linko-gift-image').replaceChildren(img);}
        } catch {card.dataset.available='false';}
      }));
    }
    owned(item) {return ['intune-1000','tiered-v2','sync-v1'].includes(item.properties?._linko_gift);}
    active(rule) { const now=Date.now();return Date.parse(rule.startsAt)<=now&&(!rule.endsAt||Date.parse(rule.endsAt)>now); }
    amount(cart,rule) {
      return cart.items.reduce((sum,item)=>{
        if(this.owned(item))return sum;
        const buys=rule.buys;const collections=this.groups.find(group=>group.productId===item.product_id)?.collections || [];
        const eligible=buys.all||buys.products.includes(item.product_id)||buys.variants.includes(item.variant_id)||collections.some(id=>buys.collections.includes(id));
        return sum+(eligible?item.original_line_price:0);
      },0);
    }
    eligible(cart,id) {
      if(!this.fresh()||cart.currency!==this.config.currency)return [];
      return (this.config.rules || []).filter(rule=>this.active(rule)&&rule.gifts.some(gift=>gift.id===id)&&this.amount(cart,rule)>=rule.minimum);
    }
    show(cart) {
      const existing=cart.items.find(item=>this.owned(item)||this.ids.includes(item.variant_id));let visible=0;
      this.cards.forEach(card=>{
        const rules=this.eligible(cart,Number(card.dataset.variant));card.hidden=!rules.length;if(rules.length)visible++;
        const button=card.querySelector('button');button.disabled=Boolean(existing)||card.dataset.available!=='true'||LinkoCartGift.busy;
        button.textContent=existing?(existing.variant_id===Number(card.dataset.variant)?this.dataset.added:this.dataset.chosen):card.dataset.available!=='true'?this.dataset.sold:this.dataset.add;
        if(rules.length)card.querySelector('.linko-gift-tier').textContent=this.dataset.tier.replace('{amount}',this.money(Math.min(...rules.map(rule=>rule.minimum))));
      });this.hidden=!visible;
    }
    sectionIds() {
      const ids = ['cart-drawer','cart-icon-bubble','cart-live-region-text'];
      const main = document.getElementById('main-cart-items');
      if (main?.dataset.id) ids.push(main.dataset.id);
      return [...new Set(ids)].slice(0,5);
    }
    render(sections) {
      for (const [id,html] of Object.entries(sections || {})) {
        if (!html) continue;
        const parsed = new DOMParser().parseFromString(html,'text/html');
        if (id === 'cart-drawer') {
          for (const selector of ['.cart-drawer__items','.cart-drawer__footer--subtotal']) {
            const target = document.querySelector('cart-drawer ' + selector);
            const source = parsed.querySelector(selector);
            if (target && source) target.innerHTML = source.innerHTML;
          }
        } else if (id === 'cart-icon-bubble') {
          const target = document.getElementById(id);
          const source = parsed.querySelector('.shopify-section');
          if (target && source) target.innerHTML = source.innerHTML;
        } else if (id === 'cart-live-region-text') {
          const target = document.getElementById(id);
          const source = parsed.querySelector('.shopify-section');
          if (target && source) target.innerHTML = source.innerHTML;
        } else {
          for (const selector of ['#main-cart-items .js-contents','.cart__footer__js-contents']) {
            const target = document.querySelector(selector);
            const source = parsed.querySelector(selector);
            if (target && source) target.innerHTML = source.innerHTML;
          }
        }
      }
      document.querySelector('cart-drawer')?.updateProductRecommendation?.();
    }
    async removeGiftLines(lines) {
      return this.request('cart/update.js',{updates:Object.fromEntries(lines.map(item=>[item.key,0])),sections:this.sectionIds(),sections_url:location.pathname});
    }
    async refresh() {
      try {
        const cart=await this.request('cart.js');const owned=cart.items.filter(item=>this.owned(item));
        const invalid=owned.filter((item,index)=>index>0||item.quantity!==1||!this.eligible(cart,item.variant_id).length||item.final_line_price!==0);
        if(invalid.length&&!LinkoCartGift.busy){LinkoCartGift.busy=true;try{const data=await this.removeGiftLines(invalid);this.render(data.sections);}finally{LinkoCartGift.busy=false;}document.querySelectorAll('linko-cart-gift').forEach(el=>el.refresh());}
        else{this.show(cart);}
      } catch{this.cards.forEach(card=>card.querySelector('button').disabled=true);this.feedback.textContent=this.dataset.error;}
    }
    async addGift(card) {
      if(LinkoCartGift.busy)return;
      const selectedId=Number(card.dataset.variant);
      await this.syncData();
      card=this.cards.find(item=>Number(item.dataset.variant)===selectedId);
      if(!card)return;
      LinkoCartGift.busy=true;this.cards.forEach(item=>item.querySelector('button').disabled=true);card.querySelector('button').textContent=this.dataset.busy;this.feedback.textContent='';let error='';
      try{
        const before=await this.request('cart.js');const id=Number(card.dataset.variant);
        if(!this.eligible(before,id).length||before.items.some(item=>this.owned(item)||this.ids.includes(item.variant_id))){this.show(before);return;}
        const added=await this.request('cart/add.js',{items:[{id,quantity:1,properties:{_linko_gift:'sync-v1'}}],sections:this.sectionIds(),sections_url:location.pathname});
        const cart=await this.request('cart.js');const gift=cart.items.find(item=>item.variant_id===id&&this.owned(item));
        if(!gift||gift.final_line_price!==0){if(gift){const removed=await this.removeGiftLines([gift]);this.render(removed.sections);}throw new Error(this.dataset.discountError);}
        this.render(added.sections);
      }catch(e){error=e.message||this.dataset.error;}
      finally{LinkoCartGift.busy=false;document.querySelectorAll('linko-cart-gift').forEach(el=>{el.refresh();if(error)el.feedback.textContent=error;});}
    }
  }
  customElements.define('linko-cart-gift',LinkoCartGift);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["linko-search-suggest"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.linkoSmartSearch) return;
  window.linkoSmartSearch = true;

  var SYNONYMS = {
    '鎖': '智能門鎖',
    '門鎖': '智能門鎖',
    '電子鎖': '智能門鎖',
    '智能鎖': '智能門鎖',
    'lock': '智能門鎖',
    'locks': '智能門鎖',
    'door lock': '智能門鎖',
    'doorlock': '智能門鎖',
    'smart lock': '智能門鎖',
    '燈掣': '燈掣插座',
    '開關': '智能開關',
    '插蘇': '插座',
    '插座': '燈掣插座',
    'switch': '燈掣插座',
    'socket': '燈掣插座',
    'sockets': '燈掣插座',
    '叉電': 'Schneider Charge',
    '叉電車': 'Schneider Charge',
    '充電樁': 'Schneider Charge',
    '充電站': 'Schneider Charge',
    'ev': 'Schneider Charge',
    'evc': 'Schneider Charge',
    'charger': 'Schneider Charge',
    'ev charger': 'Schneider Charge',
    'homekit': 'HomeKit',
    'home kit': 'HomeKit',
    '蘋果': 'HomeKit',
    'apple home': 'HomeKit',
    '網關': '網關',
    'hub': '網關',
    'gateway': '網關',
    'aqara': 'Aqara',
    '綠米': 'Aqara',
    'lockly': 'Lockly',
    'philips': 'Philips 門鎖',
    '飛利浦': 'Philips 門鎖',
    '鹿客': '鹿客',
    'lockin': '鹿客',
    '軌道燈': '磁吸軌道燈',
    '路軌燈': '磁吸軌道燈',
    '磁吸': '磁吸軌道燈',
    'p20': 'Yeelight Pro P20'
  };

  window.linkoRewriteQuery = function (query) {
    if (!query) return query;
    var key = String(query).trim().toLowerCase();
    return SYNONYMS[key] || query;
  };

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var input = form.querySelector('input[name="q"][type="search"], input[name="q"][type="text"]');
    if (!input || !form.getAttribute('action')) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1 && action.indexOf('search') === -1) return;
    var rewritten = window.linkoRewriteQuery(input.value);
    if (rewritten && rewritten !== input.value) input.value = rewritten;
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
